
/* styles */
require("!!../../node_modules/.2.1.0@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/.10.3.0@vue-loader/lib/style-rewriter?id=data-v-d923c462!../../node_modules/.10.3.0@vue-loader/lib/selector?type=styles&index=0!./Detail.vue")

var Component = require("!../../node_modules/.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.10.3.0@vue-loader/lib/selector?type=script&index=0!./Detail.vue"),
  /* template */
  require("!!../../node_modules/.10.3.0@vue-loader/lib/template-compiler?id=data-v-d923c462!../../node_modules/.10.3.0@vue-loader/lib/selector?type=template&index=0!./Detail.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Detail.vue
// module id = 19
// module chunks = 0